import { render, staticRenderFns } from "./headerNoticePop.vue?vue&type=template&id=41e1bd75&scoped=true"
import script from "./headerNoticePop.vue?vue&type=script&lang=ts"
export * from "./headerNoticePop.vue?vue&type=script&lang=ts"
import style0 from "./headerNoticePop.vue?vue&type=style&index=0&id=41e1bd75&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41e1bd75",
  null
  
)

export default component.exports